export default __webpack_public_path__ + "static/media/facility_01_2.3fd67fe2.png";